import React from 'react';
import { connect } from 'react-redux';
import { AccessHelper } from '../../helpers';

const PageLevelAccess = ({ me, to, children }) => AccessHelper.userHasAccess(me.availableRoutes, to) && <React.Fragment>{children}</React.Fragment>;

export default connect((state) => ({ me: state.user.me }))(PageLevelAccess);